import React, { useEffect, useState } from "react";
import URL from "../../assets/images/url.svg";
import vcard from "../../assets/images/icon-qr-vcard.svg";
import business from "../../assets/images/icon-qr-business.svg";
import social from "../../assets/images/icon-qr-social.svg";
import apps from "../../assets/images/icon-qr-apps.svg";
import video from "../../assets/images/icon-qr-video.svg";
import pdf from "../../assets/images/icon-qr-pdf.svg";
import links from "../../assets/images/icon-qr-links.svg";
import wifi from "../../assets/images/icon-qr-wifi.svg";
import gallery from "../../assets/images/icon-qr-image.svg";
import youtube from "../../assets/images/icon-qr-youtube.svg";
import landing from "../../assets/images/icon-qr-website.svg";
import event from "../../assets/images/icon-qr-event.svg";
import {
  BottomWrapperStages,
  Header,
  SubscriptionPopup,
} from "../../components";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetQrData } from "../../redux/slice/qrSlice";

const QrCreator = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((store) => store.user);

  useEffect(() => {
    dispatch(resetQrData());
  }, [dispatch]);
  // const { user } = useSelector((store) => store.user);
  const subPlan = user?.user?.subscription_plan || user?.subscription_plan;
  console.log("userrSTAGING", user);
  console.log("subPlan", subPlan);
  const [selectedCard, setSelectedCard] = useState(null);
  const qrCodesList = [
    {
      type: "url",
      title: "URL",
      description: "Link to a website of your choice",
      imgSrc: "/assets/images/qr-icons/url.png",
      rightImage: "/assets/images/phone-url.png",
    },
    {
      type: "vcard",
      title: "vCard",
      description: "Create a virtual business card",
      imgSrc: "/assets/images/qr-icons/vcard.png",
      rightImage: "/assets/images/phone-vcard.png",
    },
    {
      type: "business_page",
      title: "Business Page",
      description: "Display your business information",
      imgSrc: "/assets/images/qr-icons/business.png",
      rightImage: "/assets/images/phone-business.png",
    },
    {
      type: "social_media",
      title: "Social Media",
      description: "Link to your social media channels",
      imgSrc: "/assets/images/qr-icons/social.png",
      rightImage: "/assets/images/phone-social.png",
    },
    {
      type: "apps",
      title: "Apps",
      description: "Redirect to biggest app stores",
      imgSrc: "/assets/images/qr-icons/app.png",
      rightImage: "/assets/images/phone-apps.png",
    },
    {
      type: "video",
      title: "Video",
      description: "Share one or multiple videos",
      imgSrc: "/assets/images/qr-icons/video.png",
      rightImage: "/assets/images/phone-video.png",
    },
    {
      type: "pdf",
      title: "PDF",
      description: "Scan to display a PDF file",
      imgSrc: "/assets/images/qr-icons/pdf.png",
      rightImage: "/assets/images/phone-pdf.png",
    },
    {
      type: "links",
      title: "Links",
      description: "Create a list of useful links",
      imgSrc: "/assets/images/qr-icons/link.png",
      rightImage: "/assets/images/phone-links.png",
    },
    {
      type: "wifi",
      title: "Wi-Fi",
      description: "Connect to wireless network",
      imgSrc: "/assets/images/qr-icons/wifi.png",
      rightImage: "/assets/images/phone-wifi.png",
    },
    {
      type: "image_gallery",
      title: "Images Gallery",
      description: "Show a gallery of images",
      imgSrc: "/assets/images/qr-icons/image.png",
      rightImage: "/assets/images/phone-image.png",
    },
    {
      type: "youtube",
      title: "YouTube",
      description: "Take users to a YouTube video",
      imgSrc: "/assets/images/qr-icons/youtube.png",
      rightImage: "/assets/images/phone-youtube.png",
    },
    {
      type: "landing",
      title: "Landing Page",
      description: "Create your own website",
     imgSrc: "/assets/images/qr-icons/landing.png",
      rightImage: "/assets/images/phone-website.png",
    },
    {
      type: "events",
      title: "Event",
      description: "Share event info and invite guests",
      imgSrc: "/assets/images/qr-icons/event.png",
      rightImage: "/assets/images/phone-event.png",
    },
    {
      type: "elabels",
      title: "E-labels",
      description: "Create QR codes for product details.",
      imgSrc: "/assets/images/qr-icons/elabels.png",
      rightImage: "/assets/images/phone-event.png",
    },
  ];
  const handleCardClick = (type) => {
    setSelectedCard(type);
    // navigate(`/qr-editor/${type}`);
  };
  const handleNextClick = () => {
    if (selectedCard) {
      navigate(`/qr-editor/${selectedCard}`);
    }
  };
  const handleCancelClick = () => {
    setSelectedCard(null);
    navigate(`/my-qr-codes`);
  };

  const allowedQrCodes = {
    "Limited Access": ["url", "vcard", "wifi"],
    "Full Access": ["url", "vcard", "social_media", "wifi", "video"],
    "Yearly UnLimited": [
      "url",
      "vcard",
      "business_page",
      "social_media",
      "wifi",
      "video",
      "apps",
      "pdf",
      "links",
      "gallery",
      "image_gallery",
      "youtube",
      "landing",
      "events",
      "elabels",
    ],
  };
  // Filter the QR codes based on the user's subscription plan
  const filteredQrCodes = qrCodesList.filter((qrCode) =>
    allowedQrCodes[subPlan]?.includes(qrCode.type)
  );
  // console.log("filteredQrCodes",filteredQrCodes)

  return (
    <>
      <Header />
      {user?.user?.expiry === false || user?.expiry === false ? (
        <div className="qr-creator-main">
          <div className="qr-layout">
            <div className="qr-selection">
              <h1 className="qr-title">
                1. Select the QR code you want to create:
              </h1>
              <div className="qr-card-grid">
                {qrCodesList?.map((qrCode) => (
                  <div
                    key={qrCode.type}
                    className={`qr-card ${
                      selectedCard === qrCode.type ? "active" : ""
                    }`}
                    onClick={() => handleCardClick(qrCode.type)}
                  >
                    <div className="qr-card-image">
                      <img src={qrCode.imgSrc} alt={qrCode.type} />
                    </div>
                    <div className="qr-card-content">
                      <h2>{qrCode.title}</h2>
                      <p>{qrCode.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="qr-preview d-none">
              <img
                src={
                  selectedCard
                    ? qrCodesList.find((qrCode) => qrCode.type === selectedCard)
                        ?.rightImage
                    : "/assets/images/phone-example-default.png"
                }
                alt="phone-preview"
                className="qr-preview-image"
              />
            </div>
          </div>

          <BottomWrapperStages
            currentStage={1}
            onNextClick={handleNextClick}
            onCancelClick={handleCancelClick}
            showNextButton={Boolean(selectedCard)}
          />
        </div>
      ) : (
        <div style={{ paddingInline: "80px" }}>
          <SubscriptionPopup />
        </div>
      )}
    </>
  );
};

export default QrCreator;
